// Export the Component Definition for use in Contentful Studio
export {CurriculumSnapshotContentfulComponentDefinition} from './CurriculumSnapshotContentfulDefinition';
export {default} from './CurriculumSnapshot';
